import { CatHeading } from 'components/blocks-components';
import { useTranslations } from 'next-intl';
import { CustomStyledLabel } from '@cat-ecom/pcc-components';
import { CurrentItems } from 'services/fbtItems/types';
import { FC } from 'react';
import { ProductDealerPriceAvailability } from 'services/dealerPriceAvailability/types';
import styles from './fbt-mobile-drawer-content.module.scss';
import FbtItemCard from './fbt-item-card';

interface FbtCurrentItemContentProps {
  currentItem: CurrentItems;
  partsPriceData: ProductDealerPriceAvailability[];
  currency: string;
  isCatCorp: boolean;
  frequestBoughtMobile: boolean;
  contactDealerComp: React.ReactNode;
  handleCheckboxChange: (
    e: CustomEvent<{ checked: boolean; indeterminate: boolean; value: string }>
  ) => void;
  isRTL?: boolean;
  currencyLdFeatureFlag?: boolean;
  cartId: string;
  storeLocationId: string;
}

export const FbtCurrentItemContent: FC<FbtCurrentItemContentProps> = ({
  currentItem,
  partsPriceData,
  currency,
  isCatCorp,
  frequestBoughtMobile,
  contactDealerComp,
  handleCheckboxChange,
  isRTL = false,
  currencyLdFeatureFlag = false,
  cartId,
  storeLocationId
}) => {
  const t = useTranslations();
  return (
    <>
      <CatHeading variant="label">
        <CustomStyledLabel className={styles['cat-heading']}>
          {t('PDP_THIS_ITEM')}
        </CustomStyledLabel>
      </CatHeading>
      <FbtItemCard
        fbtItem={currentItem}
        partsPriceData={partsPriceData}
        currency={currency}
        isCatCorp={isCatCorp}
        frequestBoughtMobile={frequestBoughtMobile}
        isCurrentItem={true}
        handleCheckboxChange={handleCheckboxChange}
        contactDealerComp={contactDealerComp}
        isRTL={isRTL}
        currencyLdFeatureFlag={currencyLdFeatureFlag}
        startIndex={1}
        cartId={cartId}
        storeLocationId={storeLocationId}
      />
    </>
  );
};
